<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Library</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school library! Our library is a treasure trove of knowledge and learning resources, providing students with a vast collection of books, periodicals, and digital media to support their academic and personal growth.</p>
                    <p class="inner-lead">At our school, we believe that the library is the heart of the school, providing students with the resources and support they need to succeed in their academic and personal lives. We are committed to providing our students with the best possible library experience, fostering a lifelong love of learning and reading.</p> 
                    <p class="inner-lead">Our library also provides a peaceful and conducive environment for students to study, research and explore new ideas. We believe that reading is an essential skill that helps students develop critical thinking, empathy, and imagination, which are all critical for success in their future careers.</p>
                    <p class="inner-lead">Our library is a place where students can find inspiration, explore new ideas and embark on exciting intellectual journeys that will shape their lives forever.</p>
                    <div class="row">
                      <div class="col-12 col-md-6 mb-4 text-center" *ngFor="let img of imgUrl;">
                          <a href="{{img}}" data-lightbox="Library"><img [src]="img" alt="Library" class="img-fluid rounded"></a>
                      </div>
                    </div> 
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>